module.exports = __webpack_public_path__ + "img/heel_image.f32ff162.svg";